import type { Logger } from '@devhacker/shared/libs/logger';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';
import type { ISinglePostPayload, ISinglePostResponse } from '~/types/api/single-post';
import { parseData } from '@devhacker/shared/utils/parseData';
import { API_TIMEOUT, API_URL, API_URL_PREFIX } from '~/constants/config';
import { singlePostSchema } from '~/schemas/singlePostSchema';
import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { parseJsonBigIntIds } from '@devhacker/shared/libs/fetch/parseJsonBigIntIds';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params) => {
  const singlePostFetch = createAxiosLikeFetch({
    baseURL: `${API_URL}${API_URL_PREFIX}`,
    timeout: API_TIMEOUT,
    credentials: 'include',
    parseResponse: parseJsonBigIntIds, // без этого API может вернуть 200 код и html
    ...createLoggerInterceptors($logger, 'single-post'),
  });

  return {
    async fetchArticleData(payload: ISinglePostPayload) {
      const params = {
        post_slug: payload.post_slug,
      };

      const response = await singlePostFetch(
        payload.id ? `single-post/${payload.id}` : 'single-post',
        { params },
      );

      return parseData(response.data, singlePostSchema) as ISinglePostResponse;
    },
  };
};
